export default function compareMedications(a, b) {
  if (!a || !b) return false;
  return (
    (a.medication === b.medication && a.abdaMedication === undefined) ||
    (a.abdaMedication === b.abdaMedication && a.medication === undefined)
  );
}
